export default __webpack_public_path__ + "static/media/onions.9d8ccd0b.jpg";